<template>
  <b-row
    v-show="visible"
    no-gutters
    class="waitBlock justify-content-center">
    <span
      v-if="waitPeople.length == 0"
      class="waitBlockText">
      {{ $t('MEETING.NO_PARTICIPANTS_WAITING') }}
    </span>
    <span
      v-if="waitPeople.length == 1"
      class="waitBlockText">
      {{ waitPeople[0].firstName + " " + waitPeople[0].lastName + $t('MEETING.ONE_PARTICIPANT_WAITING') }}
    </span>
    <span
      v-if="waitPeople.length > 1"
      class="waitBlockText">
      {{ waitPeople.length + " " + $t('MEETING.PARTICIPANTS_WAITING') }}
    </span>
    <div
    class="d-flex justify-content-between">
      <button
        style="margin-left:16px"
        class="btn-sm btn btn-grey"
        @click="startWebinar">
      {{ $t('MEETING.START_WEBINAR') }}</button>
    </div>
  </b-row>
</template>

<script>
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'WebinarBlueBar',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    waitPeople: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    function startWebinar() {
      console.log("start webinar meeting ")
      context.parent.$parent.webrtcMeta.send(JSON.stringify({
        d_type: "WSMeetingModify",
        webinarStarted: 1
      }))
    }
    
    return {
      startWebinar
    }
  }
}
</script>
<style>
.waitBlock {
    position: absolute;
    padding: 4px 12px;
    border-radius: 4px;
    z-index: 300;
    background-color: #0072E5;
    left: 50%;
    width: auto;
    transform: translateX(-50%);
  }
  .waitBlockText {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
  }
</style>


// WEBPACK FOOTER //
// src/components/WebinarBlueBar.vue